import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import InvoiceNotesService from "../../Controller/InvoiceNotesController";
import CreateInvoiceNotes from "./CreateInvoiceNotes";
import HelpSite from "../../../Common/HelpLink";
import InvoiceService from "../../Controller/InvoiceController";
import SunTextEditor from "../../../Common/SunTextEditor";
function InvoiceNotesPage({ InvoiceID }) {
    const navigate = useNavigate();
    const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
    };
    InvoiceID = localStorage.getItem('InvoiceID');


    const [SaleOrdeNotesList, setInvoiceNotes] = useState([]);

    const [modalInstance, setModalInstance] = useState(null);
    const [currentInvoiceNotes, setCurrentInvoiceNotes] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isClosed, SetIsClosed] = useState("0");
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };
    const fetchInvoiceNotes = async () => {
        try {
            const data = await InvoiceNotesService.GetAllInvoiceNotes(redirectCallback, InvoiceID);
            setInvoiceNotes(data);
        } catch (error) {
            console.error('Error fetching Contacts:', error);
        }
    };
    const fetchInvoiceDetail = async () => {
        try {
            const redirectCallback = () => navigate('/');
            if (InvoiceID > 0) {
                const saleOrderDetail = await InvoiceService.GetInvoiceByID(redirectCallback, InvoiceID);
                const saleOrder = saleOrderDetail[0];
                if (saleOrder.bit_DropShipment > 0 || saleOrder.bit_DropShipmentc > 0) {
                    SetIsClosed("1");
                }

            }
        } catch (error) {
            console.error('Error fetching agreement details:', error);
        }
    };
    useEffect(() => {
        SetIsClosed("0");
        fetchInvoiceDetail();
        fetchInvoiceNotes();
    }, [InvoiceID]);

    const handleCreateInvoiceNotesClick = () => {
        setCurrentInvoiceNotes(null);
        fetchInvoiceNotes();
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    const handleEditClick = (history) => {
        setCurrentInvoiceNotes(history);
        fetchInvoiceNotes();
        setIsModalOpen(true);
    };
    const handleSuccess = () => {
        fetchInvoiceNotes();// Refresh the list after submission
        handleCloseModal();   // Close the modal
    };

    const handleDeleteClick = async (ID, redirectCallback) => {
        const confirmed = window.confirm("Are you sure you want to delete this contact?");
        if (confirmed) {
            try {
                await InvoiceNotesService.DeleteInvoiceNotes(ID, redirectCallback);
                fetchInvoiceNotes(); // Refresh the list after deletion
            } catch (error) {
                console.error('Error deleting Contact:', error);
            }
        }
    };
    const HelpLink = localStorage.getItem('HelpLink');
    return (
        <div>
            <div className="row mb-3" style={{ marginLeft: "-5px" }}>
                <div className="col-sm-3">
                    <button className={`btn btn-primary btn-sm ${localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} onClick={handleCreateInvoiceNotesClick} disabled={isClosed === '1' || isClosed === 1}>
                        <i className="icofont-plus" aria-hidden="true"> Add New</i>
                    </button>
                </div>
                <div className="col-sm-9" style={{ "textAlign": "right" }}>

                </div>
            </div>
            <div className="row mb-3" style={{ marginLeft: "-5px" }}>
                <div className="col-sm-12">
                    <div className="">
                        <table className="table m-0 table-hover">
                            <thead>
                                <tr>
                                    <th>Created</th>
                                    <th>Created By</th>
                                    <th>Description</th>

                                    <th style={{ "textAlign": "right" }}>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {SaleOrdeNotesList.map((notes) => (
                                    <tr key={notes.PK_SalesOrderNotes_ID} onClick={() => handleEditClick(notes)} disabled={isClosed === '1' || isClosed === 1 || localStorage.getItem('LicenseExpired') == "1"}>
                                        <td>{formatDate(notes.dt_Created)}</td>
                                        <td>{notes.DisplayName}</td>

                                        <td dangerouslySetInnerHTML={{ __html: notes.vc_Description }}></td>


                                        <td style={{ "textAlign": "right" }}>

                                            <button style={{ "background": "none", "border": "none" }} className="text-danger" onClick={() => handleDeleteClick(notes.PK_SalesOrderNotes_ID)} disabled={isClosed === '1' || isClosed === 1 || localStorage.getItem('LicenseExpired') == "1"}>
                                                <i className="icofont-ui-delete" aria-hidden="true"></i>
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            {isModalOpen && (
                <CreateInvoiceNotes
                    modalInstance={modalInstance}
                    currentInvoiceNotes={currentInvoiceNotes}
                    onClose={handleCloseModal}
                    onSuccess={handleSuccess}

                    InvoiceID={InvoiceID}


                />
            )}
        </div>
    );
}

export default InvoiceNotesPage;
